module.exports = {
          srcSet: __webpack_public_path__ + "images/2005-9e324afeff87ae030cf8184ae70e8ae5-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2005-d9bb7818a3bb279ae4b4adcee13c135f-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2005-9e324afeff87ae030cf8184ae70e8ae5-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2005-d9bb7818a3bb279ae4b4adcee13c135f-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2005-9e324afeff87ae030cf8184ae70e8ae5-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2005-9e324afeff87ae030cf8184ae70e8ae5-320.jpg"},
          
          width: 320,
          height: 251
        }